// extracted by mini-css-extract-plugin
export default {"wrapper":"p94HUr","container":"dWKf8t","containerBorder":"FhgDlP","header":"R_a8Kf","content":"mBivjd","controls":"sSnXPD"};